// extracted by mini-css-extract-plugin
export default {"tableContainer":"styles_tableContainer__spUti","tableRow":"styles_tableRow__Cr0X-","tableRowItem":"styles_tableRowItem__Y0KGa","viewBtn":"styles_viewBtn__iNFNV"};